import { PerformanceAudienceChartMetric, PerformanceAudienceTrendSeries } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ChartMetricToggle } from '../ChartMetricToggle';
import { PlatformTrendChart } from '../PlatformTrendChart';
import { Card, CardHead, CardSubtitle, CardTitle } from '../PerformanceAudienceComponents';

type PerformanceAudienceTrendSectionProps = {
  trend?: PerformanceAudienceTrendSeries;
  activeMetric: PerformanceAudienceChartMetric;
  onMetricChange: (metric: PerformanceAudienceChartMetric) => void;
};

export const PerformanceAudienceTrendSection: FC<PerformanceAudienceTrendSectionProps> = ({ trend, activeMetric, onMetricChange }) => {
  const { t } = useTranslation('performanceAudience');
  const data = trend?.[activeMetric] ?? [];

  return (
    <Card>
      <CardHead>
        <div>
          <CardTitle text={t('trend.title')} />
          <CardSubtitle text={t('trend.subtitle')} />
        </div>
        <ChartMetricToggle activeMetric={activeMetric} onChange={onMetricChange} />
      </CardHead>
      <PlatformTrendChart data={data} isPercentage={activeMetric === 'ctr'} />
    </Card>
  );
};
